/** @format */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { _$ } from '@king-design/react'
import NoDataComponent from 'src/components/NoData'
import dayjs from 'dayjs'
import { EchartReact } from 'src/components'
import { echartTooltipOptions } from 'src/utils/echarts'

interface IChartContentProps {
  className?: string
  chartData: any[]
}

interface IChartObjectProps {
  xData: string[]
  series: any[]
}

const ChartContent: React.FC<IChartContentProps> = ({ className, chartData }) => {
  const [chartObject, setChartObject] = useState<IChartObjectProps>({
    xData: [],
    series: []
  })

  useEffect(() => {
    // 时间戳list
    const dateArray = []
    chartData?.forEach(({ series }) => {
      dateArray.push(...series?.map(([time]) => time))
    })
    const uniqueSortDate = Array.from(new Set(dateArray)).sort((a, b) => a - b)
    // series list
    const seriesArray = []
    chartData.forEach(({ alias, series }) => {
      const seriesData = uniqueSortDate.map(dateItem => {
        const findItem = series.find(([time]) => dateItem === time)
        return findItem ? findItem[1] : null
      })
      const seriesObject = {
        name: alias,
        type: 'line',
        data: seriesData,
        showSymbol: false,
        smooth: true,
        lineStyle: {
          width: 2
        }
      }
      seriesArray.push(seriesObject)
    })
    setChartObject({
      xData: uniqueSortDate.map(date => dayjs(date).format('MM-DD HH:mm')),
      series: seriesArray
    })
  }, [chartData])
  return chartData.length ? (
    <div className={className}>
      <EchartReact
        option={{
          title: {
            text: _$('自定义监控指标')
          },
          tooltip: {
            ...echartTooltipOptions,
            hideDelay: 200, // 浮层隐藏的延迟
            confine: true,
            backgroundColor: 'rgba(255,255,255, 1)',
            formatter: function (params) {
              let htmlStr =
                '<div class="tooltip-list"><p class="tooltip-title">' + params[0].axisValue + '</p>'
              for (let i = 0; i < params.length; i++) {
                if (params[i].value) {
                  // eslint-disable-next-line max-len
                  // eslint-disable-next-line prettier/prettier
                  htmlStr += `<p class="tooltip-item">
                  ${params[i].marker + params[i].seriesName}: ${params[i].value}
                  </p>`
                }
              }
              htmlStr += '</div>'
              return htmlStr
            },
            extraCssText: 'box-shadow: 0 0 3px rgba(150,150,150, 0.7);',
            textStyle: {
              fontSize: 12,
              color: '#fff'
            }
          },
          legend: {
            left: '220px',
            type: 'scroll'
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: chartObject?.xData,
            axisLabel: {
              showMaxLabel: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            type: 'value'
          },
          series: chartObject.series,
          grid: {
            left: '50px',
            right: '20px',
            top: '10%',
            bottom: '40px'
          }
        }}
      ></EchartReact>
    </div>
  ) : (
    <div className={className}>
      <NoDataComponent style={{ padding: 150 }} />
    </div>
  )
}

export default styled(ChartContent)`
  width: 100%;
  height: 100%;
  background: #fff;
  .tooltip-list {
    height: auto;
    max-height: 240px;
    overflow-y: auto;
    .tooltip-title {
      font-weight: bold;
    }
    p {
      color: #666;
      margin: 0;
      font-size: 14px;
      line-height: 20px;
    }
  }
`
